import React from 'react'
// libs
import styled from 'styled-components'
// components
import MaterialList from '@mui/material/List'
import MaterialListItem from '@mui/material/ListItem'
import MaterialListItemIcon from '@mui/material/ListItemIcon'
import MaterialListItemText from '@mui/material/ListItemText'
// themes
import { colors } from 'themes'
// static
import MeasuresIconOrigin from 'src/icons/measures.svg'
import ObjectivesIconOrigin from '@mui/icons-material/TrackChanges'
// css
import { sidebarIconCSS } from 'themes/views/layouts'
// utils
import { size } from 'polished'

export const ListWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  position: relative;

  & > div:first-child {
    @media (max-width: 768px) {
      display: none;
    }
  }
`

export const List = styled(MaterialList)<{ $withSearch: boolean }>`
  && {
    flex-grow: 1;
    padding: 0;
    margin-top: ${({ $withSearch }) => ($withSearch ? 0 : 8)}px;

    @media (max-width: 768px) {
      margin-top: 16px;
    }

    a {
      cursor: pointer;
      color: inherit;
      text-decoration: none;

      &:hover,
      &:active,
      &:focus,
      &:visited {
        text-decoration: none;
        color: inherit;
      }
    }
  }
`

export const ListItem = styled(
  React.forwardRef<any, any>(({ $isActive, ...props }, ref) => <MaterialListItem {...props} ref={ref} />)
)<{ $isActive: boolean }>`
  && {
    height: 44px;

    ${({ $isActive }) => $isActive && `background-color: ${colors.purple300};`};

    &:hover {
      background-color: ${colors.purple300};
    }
  }
`

export const ListItemText = styled(MaterialListItemText)`
  && {
    font-weight: bold;
  }
`

export const ListItemIcon = styled(MaterialListItemIcon)`
  && {
    margin-left: 8px;
  }
`

export const MeasuresIcon = styled(MeasuresIconOrigin)`
  & {
    ${sidebarIconCSS};
    ${size('24px')};

    path {
      fill: ${colors.white100};
    }
  }
`

export const ObjectivesIcon = styled<any>(({ htmlColor, ...props }) => <ObjectivesIconOrigin {...props} />)`
  & {
    ${sidebarIconCSS}
    ${size('24px')};

    path {
      fill: ${colors.white100};
    }
  }
`

export const BigLogo = styled.img.attrs({
  src: '/images/logo.png',
  width: 188,
  height: 44
})``

export const MiniLogo = styled.img.attrs({
  src: '/images/logo-mini.png',
  width: 32,
  height: 26
})``
